
import crud from "./_crud";
import { callApi } from 'utils/api'
import { showErrorMessage, showSuccessMessage } from 'utils/messages'

const actions = crud('client_work_shift', 'el turno de cliente', 'los turnos de cliente');

const importClientWorkShifts = (options) => {
    return async (dispatch, getState) => {
        const state = getState()

        const res = await callApi(`/client_work_shift/import_client_work_shifts`, {
            method: 'POST',
            headers: {
                Authorization: state.app.user.token,
            },
            body: JSON.stringify({
                options,
            }),
            successMessage: `Se agreron los turnos correctamente.`,
        })
        showSuccessMessage('Se registraron los turnos correctamente.')
        return res.body
    }
}

export default { ...actions, importClientWorkShifts }